import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';
import { CenteredContainer } from './CenteredContainer';

export const RoundPrimitiveButton = styled(CenteredContainer)`
  border-radius: 50%;
  cursor: pointer;
  color: ${RoutalPalette.white};
`;
